export default __webpack_public_path__ + "static/media/help_3_skillreg.1545f34d.gif";